<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.obstetricConsultations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="p-1em">
                    <!--                    <h3 class="card-title text-center mb-0">-->
                    <!--                        {{fullName }} ( {{fileNumber}} )-->
                    <!--                    </h3>-->
                </div>
                <b-form @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="institution-group"
                                        :label="$t('message.institutionConsultation')"
                                        label-for="institution"
                                >
                                    <select id="institution" v-model="$v.form.etablissement_id.$model"
                                            @change="clearErrorField('etablissement_id')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="$v.form.etablissement_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <span v-if="errorshasField('etablissement_id')" style="color:red">
                                    {{getErrorsField('etablissement_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="consultation-group"
                                        :label="$t('message.consultationDate')"
                                        label-for="consultation"
                                        description="">
                                    <b-form-input
                                            id="consultation"
                                            v-model="$v.form.date_creation.$model"
                                            :state="$v.form.date_creation.$dirty ? !(errorshasField('date_creation') || $v.form.date_creation.$error) : null"
                                            type="date"
                                            required
                                            @focus="clearErrorField('date_creation')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.date_creation.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('date_creation')">
                                        {{ getErrorsField('date_creation') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="numero-grossesse-group"
                                        :label="$t('message.pregnancyNumber')"
                                        label-for="numero-grossesse"
                                        description=""
                                >
                                    <b-form-input
                                            id="numero-grossesse"
                                            v-model="$v.form.numero_grossesse.$model"
                                            :state="$v.form.numero_grossesse.$dirty ? !$v.form.numero_grossesse.$error : null"
                                            type="number"
                                            disabled
                                            required
                                            placeholder=""
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="ddr-group"
                                        :label="$t('message.ddr')"
                                        label-for="ddr">
                                    <b-form-input
                                            id="ddr"
                                            v-model="$v.form.ddr.$model"
                                            :state="$v.form.ddr.$dirty ? !$v.form.ddr.$error : null"
                                            type="date"
                                            required
                                            :max="today"
                                            @click="clearErrorField('ddr')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="$v.form.ddr.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <span v-if="errorshasField('ddr')" style="color:red">
                                    {{getErrorsField('ddr')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="serologie-group"
                                        :label="$t('message.serology')"
                                        label-for="serologie"
                                >
                                    <select id="serologie" v-model="$v.form.serologie.$model"
                                            @change="clearErrorField('serologie')" multiple
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in serologies"  :key="item" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.serologie.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('serologie')" style="color:red">
                                    {{getErrorsField('serologie')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="groupe-sanguin-group"
                                        :label="$t('message.bloodGroup')"
                                        label-for="groupe-sanguin"

                                >
                                    <select id="groupe-sanguin" v-model="$v.form.groupe_sanguin.$model"
                                            @change="clearErrorField('groupe_sanguin')"
                                            class="form-control is-invalid retirerBordure"
                                            :state="$v.form.groupe_sanguin.$dirty ? !(errorshasField('groupe_sanguin') || $v.form.groupe_sanguin.$error) : null"

                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in groupes"  :key="item" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.groupe_sanguin.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('groupe_sanguin')" style="color:red">
                                    {{getErrorsField('groupe_sanguin')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="statut-familiale-group"
                                        :label="$t('message.familyStatus')"
                                        label-for="statut-familiale"
                                >
                                    <b-form-textarea
                                            id="statut-familiale"
                                            v-model="$v.form.statut_socio_familiale.$model"
                                            placeholder=""
                                            @change="clearErrorField('statut_socio_familiale')"
                                    ></b-form-textarea>
                                    <span v-if="errorshasField('statut_socio_familiale')" style="color:red">
                                    {{getErrorsField('statut_socio_familiale')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="assuetudes-group"
                                        :label="$tc('message.addictions', 1)"
                                        label-for="assuetudes"
                                >
                                    <b-form-textarea
                                            id="assuetudes"
                                            v-model="$v.form.assuetudes.$model"
                                            placeholder=""
                                            @keydown="clearErrorField('assuetudes')"
                                    ></b-form-textarea>
                                    <span v-if="errorshasField('assuetudes')" style="color:red">
                                    {{getErrorsField('assuetudes')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="antecedent-group"
                                        :label="$t('message.transfusionAntecedent')"
                                        label-for="antecedent"
                                >
                                    <b-form-textarea
                                            id="antecedent"
                                            v-model="$v.form.antecedent_de_transfusion.$model"
                                            placeholder=""
                                            @keydown="clearErrorField('antecedent_de_transfusion')"
                                    ></b-form-textarea>
                                    <span v-if="errorshasField('antecedent_de_transfusion')" style="color:red">
                                    {{getErrorsField('antecedent_de_transfusion')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="facteur-group"
                                        :label="$t('message.riskFactor')"
                                        label-for="facteur"
                                >
                                    <b-form-textarea
                                            id="facteur"
                                            v-model="$v.form.facteur_de_risque.$model"
                                            placeholder=""
                                            @keydown="clearErrorField('facteur_de_risque')"
                                    ></b-form-textarea>
                                    <span v-if="errorshasField('facteur_de_risque')" style="color:red">
                                    {{getErrorsField('facteur_de_risque')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="antecedentSpouse-group"
                                        :label="$t('message.antecedentSpouse')"
                                        label-for="antecedentSpouse"
                                >
                                    <b-form-textarea
                                            id="antecedentSpouse"
                                            v-model="$v.form.antecedent_conjoint.$model"
                                            :state="$v.form.antecedent_conjoint.$dirty ? !$v.form.antecedent_conjoint.$error : null"
                                            placeholder=""
                                            @keydown="clearErrorField('antecedent_conjoint')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <span v-if="errorshasField('antecedent_conjoint')" style="color:red">
                                    {{getErrorsField('antecedent_conjoint')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="rcc-group"
                                        :label="$t('message.rcc')"
                                        label-for="rcc"
                                        class="form-control is-invalid retirerBordure"
                                >
                                    <select id="rcc" v-model="$v.form.rcc.$model"
                                            @change="clearErrorField('rcc')" multiple
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in rccs"  :key="item" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.rcc.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('rcc')" style="color:red">
                                    {{getErrorsField('rcc')}}
                                    </span>

                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$tc('message.pcr',1)">
                                    <b-form-radio-group id="pcr1" v-model="$v.form.pcr_gonocoque.$model" name="pcr_gonocoque">
                                        <b-form-radio   value="PCR Gono +">PCR Gono +</b-form-radio>
                                        <b-form-radio   value="PCR Gono -">PCR Gono -</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group :label="$tc('message.pcr',2)">
                                    <b-form-radio-group id="pcr12" v-model="$v.form.pcr_chlamydia.$model" name="pcr_chlamydia">
                                        <b-form-radio   value="PCR Chlam +">PCR Chlam +</b-form-radio>
                                        <b-form-radio   value="PCR Chlam -">PCR Chlam -</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="glycemie-group"
                                        :label="$t('message.glucose')"
                                        label-for="glycemie"
                                >
                                    <b-form-input
                                            id="glycemie"
                                            v-model="$v.form.glycemie.$model"
                                            :state="$v.form.glycemie.$dirty ? !(errorshasField('glycemie') || $v.form.glycemie.$error) : null"
                                            type="number"
                                            step="0.01"
                                            placeholder=""
                                            @focus="clearErrorField('glycemie')"
                                    ></b-form-input>

                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group :label="$tc('message.emu')">
                                    <b-form-radio-group id="emu" v-model="$v.form.emu.$model" name="emu">
                                        <b-form-radio   value="Negatif">Négatif</b-form-radio>
                                        <b-form-radio   value="Positif">Positif</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="tsh-group"
                                        :label="$t('message.tsh')"
                                        label-for="tsh"
                                >
                                    <b-form-input
                                            id="tsh"
                                            v-model="$v.form.tsh.$model"
                                            :state="$v.form.tsh.$dirty ? !(errorshasField('tsh') || $v.form.tsh.$error) : null"
                                            type="number"
                                            step="0.01"
                                            placeholder=""
                                            @focus="clearErrorField('tsh')"
                                    ></b-form-input>

                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="anti_tpo-group"
                                        :label="$t('message.antiTpo')"
                                        label-for="anti_tpo"
                                >
                                    <b-form-input
                                            id="anti_tpo"
                                            v-model="$v.form.anti_tpo.$model"
                                            :state="$v.form.anti_tpo.$dirty ? !(errorshasField('anti_tpo') || $v.form.anti_tpo.$error) : null"
                                            type="number"
                                            step="0.01"
                                            placeholder=""
                                            @focus="clearErrorField('anti_tpo')"
                                    ></b-form-input>

                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="ft4-group"
                                        :label="$t('message.ft4')"
                                        label-for="ft4"
                                >
                                    <b-form-input
                                            id="ft4"
                                            v-model="$v.form.ft4.$model"
                                            :state="$v.form.ft4.$dirty ? !(errorshasField('ft4') || $v.form.ft4.$error) : null"
                                            type="number"
                                            step="0.01"
                                            placeholder=""
                                            @focus="clearErrorField('ft4')"
                                    ></b-form-input>

                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="ft3-group"
                                        :label="$t('message.ft3')"
                                        label-for="ft3"
                                >
                                    <b-form-input
                                            id="anti_tpo"
                                            v-model="$v.form.ft3.$model"
                                            :state="$v.form.ft3.$dirty ? !(errorshasField('ft3') || $v.form.ft3.$error) : null"
                                            type="number"
                                            step="0.01"
                                            placeholder=""
                                            @focus="clearErrorField('ft3')"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="infoSupported-group"
                                        :label="$t('message.infoSupported')"
                                        label-for="infoSupported"
                                >
                                    <b-form-textarea
                                            id="infoSupported"
                                            v-model="$v.form.info_prise_en_charge.$model"
                                            placeholder=""
                                            @keydown="clearErrorField('info_prise_en_charge')"
                                    ></b-form-textarea>

                                    <span v-if="errorshasField('info_prise_en_charge')" style="color:red">
                                    {{getErrorsField('info_prise_en_charge')}}
                                    </span>

                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="attention-group"
                                        :label="$t('message.warning')"
                                        label-for="attention"
                                >
                                    <b-form-textarea
                                            id="attention"
                                            v-model="$v.form.attention.$model"
                                            placeholder=""
                                            @keydown="clearErrorField('attention')"
                                    ></b-form-textarea>

                                    <span v-if="errorshasField('attention')" style="color:red">
                                    {{getErrorsField('attention')}}
                                    </span>

                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="t1-group"
                                        :label="$t('message.t1')"
                                        label-for="t1"
                                >
                                    <select id="t1" v-model="form.t1"
                                            @change="clearErrorField('t1')"
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in t1s"  :key="item.value" :value="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.t1.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('t1')" style="color:red">
                                    {{getErrorsField('t1')}}
                                    </span>

                                </b-form-group>
                            </b-col>

                            <b-col sm="12" v-if="form.t1 == 'nipt'">
                                <b-form-group :label="$t('message.nle_anle')">
                                    <b-form-radio-group id="nle_anle" v-model="$v.form.nle_anle.$model" name="nle_anle">
                                        <b-form-radio   value="Oui">Oui</b-form-radio>
                                        <b-form-radio   value="Non">Non</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                                <b-form-group :label="$t('message.gender')">
                                    <b-form-radio-group id="sexe" v-model="$v.form.sexe.$model" name="sexe">
                                        <b-form-radio   value="XX">XX</b-form-radio>
                                        <b-form-radio   value="XY">XY</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="date_rdv"
                                        :label="$t('message.appointmentDate')"
                                        label-for="appointmentDate"
                                >
                                    <vue-ctk-date-time-picker class="border-dark" v-model="$v.form.rdv.date.$model"></vue-ctk-date-time-picker>
                                </b-form-group>

                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="traitement-appointmentReason-group"
                                        :label="$t('message.appointmentReason')"
                                        label-for="appointmentReason"
                                >
                                    <editor
                                            :api-key="tinyKey"
                                            id="appointmentReason"
                                            v-model="$v.form.rdv.motifs.$model"
                                            :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                                    >
                                    </editor>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="justify-content-sm-center">
                            <b-button @click="onSubmit" variant="primary" v-if="form.isAuthor || hasAdminRole">
                                {{ $t('message.edit') }}
                            </b-button>

                            <!--                            <b-button type="reset" variant="danger" v-if="form.isAuthor || hasAdminRole">-->
                            <!--                                {{ $t('message.reset') }}-->
                            <!--                            </b-button>-->
                        </b-row>
                    </b-container>


                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import moment from 'moment';
    import SlimSelect from 'slim-select';
    import _ from 'lodash';
    import Editor from "@tinymce/tinymce-vue";
    import AppConfig from "../../../constants/AppConfig";

    export default {
        name: "EditObstetric",
        components: {
            editor: Editor
        },
        computed: {
            ...mapGetters(["obstetricConsultation",
                'errors',
                'hasAdminRole',
                "userInstitutions",
                'hasMedecinControleRole',
                'hasAssistante',
                'hasPraticienRole']),

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

            form: function() {
                let obstetricConsultation = this.obstetricConsultation;
                let serologie = obstetricConsultation['serologie'];
                let rcc = obstetricConsultation['rcc'];
                delete obstetricConsultation['serologie'];
                delete obstetricConsultation['rcc'];
                obstetricConsultation['serologie'] = _.words(serologie, /[^ ]+/g);
                obstetricConsultation['rcc'] = _.words(rcc, /[^ ]+/g);

                if (_.isNull(obstetricConsultation.rdv)){
                    obstetricConsultation.rdv = [];
                    obstetricConsultation.rdv['date']='';
                    obstetricConsultation.rdv['motif']='';
                }

                return obstetricConsultation;
            },

            fullName:function(){
                if (typeof (this.form.user) == 'object'){
                    let user = this.form.user;
                    let prenom = (user.prenom != null ? user.prenom : '');
                    prenom =  prenom.toLowerCase();
                    return ( user.nom ).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                }else{
                    return '';
                }
            },
            fileNumber:function() {
                if (typeof (this.form.dossier) == 'object'){
                    let dossier = this.form.dossier;
                    return dossier.numero_dossier;
                }else{
                    return '';
                }
            },

            mInstitutions: function() {
                let iArray = [];

                _.forEach(_.orderBy(this.userInstitutions,['created_at'],['desc']), function(institution) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = (!_.isNull(institution.description)? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
                    i.date = moment(institution.created_at).format('DD-MM-YYYY');
                    i.id = institution.id;
                    i.slug = institution.slug;

                    iArray.push(i);
                });

                return iArray;
            },

            today:function () {
                return moment((new Date())).format('YYYY-MM-DD');
            }
        },

        data() {
            return {
                tinyKey: AppConfig.tinyMceKey,
                plugins: [
                    'advlist autolink lists  image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table'
                ],
                toolbar: 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
                consultation_id: this.$route.params.consultation,
                show: true,
                groupes: ['A-', 'A+', 'B-', 'B+', 'AB-', 'AB+', 'O-', 'O+'],
                serologies:['Rubéole+','Rubéole-','Toxo+','Toxo-','HBV-','HIV-','HCV+'],
                rccs:['RCC-NLE','RCC-ASCUS','RCC-LSIL','RCC-ASCH','RCC-CIN1','RCC-CIN2','RCC-CIN3','RCC-CIS'],
                t1s:[{text:'NIPT',value:'nipt'},{text:'Bi-test',value:'bi_test'},{text:'Non spécifié',value:'Non spécifié'}],

            }
        },

        methods: {
            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },

            getConsultation: function() {
                let args = {
                    consultation: this.consultation_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getObstetricConsultation', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    if (!_.isNull(this.form.dateRdv)){
                        this.form.rdv.date = moment(this.form.rdv.date).format('YYYY-MM-DD HH:mm');
                    }
                    let args = {
                        dossier_medical_id:this.form.dossier.id,
                        consultation: this.consultation_id,
                        numero_grossesse: this.form.numero_grossesse,
                        ddr: this.form.ddr,
                        date_creation: this.form.date_creation,
                        serologie: this.form.serologie,
                        groupe_sanguin: this.form.groupe_sanguin,
                        statut_socio_familiale: this.form.statut_socio_familiale,
                        assuetudes: this.form.assuetudes,
                        antecedent_de_transfusion: this.form.antecedent_de_transfusion,
                        facteur_de_risque: this.form.facteur_de_risque,
                        antecedent_conjoint: this.form.antecedent_conjoint,
                        etablissement_id: this.form.etablissement_id,
                        pcr_gonocoque: this.form.pcr_gonocoque,
                        pcr_chlamydia: this.form.pcr_chlamydia,
                        glycemie: this.form.glycemie,
                        attention: this.form.attention,
                        tsh: this.form.tsh,
                        ft3: this.form.ft3,
                        emu: this.form.emu,
                        ft4: this.form.ft4,
                        anti_tpo: this.form.anti_tpo,
                        info_prise_en_charge: this.form.info_prise_en_charge,
                        rcc: this.form.rcc,
                        t1:this.form.t1,
                        sexe:this.form.sexe,
                        nle_anle:this.form.nle_anle,
                        motifRdv:this.form.rdv.motifs,
                        dateRdv:this.form.rdv.date,
                    };

                    let successMessage = this.$i18n.t('message.obstetricConsultationUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateObstetricConsultation', { args, errorMessages, successMessage });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.numero_grossesse = '';
                this.form.ddr = '';
                this.form.serologie = '';
                this.form.groupe_sanguin = '';
                this.form.statut_socio_familiale = '';
                this.form.assuetudes = '';
                this.form.antecedent_de_transfusion = '';
                this.form.facteur_de_risque = '';
                this.form.date_creation = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }

        },

        validations: {
            form: {

                rdv:{
                    date:{},
                    motifs:{}
                },
                t1: {
                    //
                },

                sexe: {
                    //
                },

                nle_anle: {
                    //
                },

                etablissement_id:{
                    required
                },
                pcr_gonocoque: {
                    required
                },

                pcr_chlamydia: {
                    required
                },
                attention: {
                    //
                },

                emu: {
                    //
                },

                ft3: {
                    //
                },

                ft4: {
                    //
                },

                anti_tpo: {
                    //
                },

                tsh: {
                    //
                },

                info_prise_en_charge: {
                    //
                },

                glycemie: {
                    //
                },

                rcc: {
                    //
                },

                dossier_medical_id:{
                    required
                },
                numero_grossesse: {
                    required
                },

                ddr: {
                    required
                },

                date_creation: {
                    required
                },

                serologie: {
                    //
                },

                groupe_sanguin: {
                    //
                },

                statut_socio_familiale: {
                    //
                },

                assuetudes: {
                    //
                },

                antecedent_de_transfusion: {
                    //
                },

                facteur_de_risque: {
                    //
                },
                antecedent_conjoint:{
                    //
                }
            }
        },

        mounted() {
            // Fetch user institution list
            this.getUserInstitutions();

            // Retrieve consultation
            this.getConsultation();

            var select =  new SlimSelect({
                select: '#serologie',
                placeholder: 'Select a serologie',
                addable: function (value) {
                    // Return the value string
                    return value // Optional - value alteration // ex: value.toLowerCase()
                }
            });

            async function waitForCondition(element) {

                while (true) {
                    if (typeof element.form.serologie == 'object') {
                        select.set(element.form.serologie);
                        break; // or return
                    }
                    await new Promise(resolve => setTimeout(resolve, 1000));
                }

            }

            waitForCondition(this);

            new SlimSelect({
                select: '#groupe-sanguin',
                placeholder: 'Group sanguin',

            });

            new SlimSelect({
                select: '#institution',
                placeholder: 'Select institution',
                limit:1
            });

            new SlimSelect({
                select: '#rcc',
                placeholder: 'Select a rcc',
            });

            new SlimSelect({
                select: '#t1',
                placeholder: 'select t1',
            });

        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>